/**
 * Conditional Logger - Only logs in development mode
 * Production logs are stripped for performance
 */

const isDev = import.meta.env.DEV

export const logger = {
  log: (...args: any[]) => {
    if (isDev) console.log(...args)
  },
  
  warn: (...args: any[]) => {
    if (isDev) console.warn(...args)
  },
  
  error: (...args: any[]) => {
    // Always log errors, even in production
    console.error(...args)
  },
  
  debug: (...args: any[]) => {
    if (isDev) console.debug(...args)
  },
  
  info: (...args: any[]) => {
    if (isDev) console.info(...args)
  }
}

// Export a no-op logger for production builds
export const createLogger = (namespace: string) => ({
  log: (...args: any[]) => logger.log(`[${namespace}]`, ...args),
  warn: (...args: any[]) => logger.warn(`[${namespace}]`, ...args),
  error: (...args: any[]) => logger.error(`[${namespace}]`, ...args),
  debug: (...args: any[]) => logger.debug(`[${namespace}]`, ...args),
  info: (...args: any[]) => logger.info(`[${namespace}]`, ...args),
})
